import CTA2 from './CTA2'
export default CTA2
